<template>
  <section v-for="(recommendation, index) in item.content" :key="index" class="pt-5">
    <div class="recommendation-item-details">
      <v-sheet v-if="recommendation.image_url" class="logo-container m-0">
        <div
          :style="{ backgroundImage: `url(${recommendation.image_url})` }"
          class="logo-container__image"
        ></div>
      </v-sheet>

      <v-card-text class="pa-0">
        <h3 class="font-size-16-600">{{ recommendation.name }}</h3>
        <p v-if="recommendation.description" class="mt-1 mb-2 font-size-16-400">
          {{ recommendation.description }}
        </p>
        <a
          v-if="recommendation.url"
          :href="recommendation.url"
          target="_blank"
          class="font-size-16-400 text-primary"
        >
          {{ recommendation.url }}
        </a>
      </v-card-text>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  item: Object,
});
</script>

<style lang="scss" scoped>
.recommendation-item-details {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px;

  .logo-container {
    width: 126px;
    height: 100px;

    &__image {
      border-radius: 5px;
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}

.font-size-16-600 {
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
}

.font-size-16-400 {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 12px;
}
</style>
